var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeDesktopShortDislike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 19,
  viewBox: "0 0 20 19",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.13 12.132c-.478 0-.93-.21-1.229-.57l-.556-.67a1.47 1.47 0 0 1-.12-1.728l.956-1.536-.544-1.31a2.21 2.21 0 0 1 .304-2.21l.705-.907V1.516C1.646.68 2.35 0 3.22 0h9.964c.869 0 1.573.679 1.573 1.516v9.987a2.96 2.96 0 0 1-.586 1.763l-4.13 5.575a.4.4 0 0 1-.476.128l-.056-.023C8.065 18.35 7.3 16.82 7.712 15.36l.913-3.228zm16.297-1.01c.869 0 1.573-.678 1.573-1.516V1.518c0-.837-.704-1.516-1.573-1.516h-2.098v11.12z"
})));
export default SvgYoutubeDesktopShortDislike;